import i18n from 'i18next';
import { get } from 'lodash';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import moment from 'moment';
import window from 'common/utils/window-or-global';

if (window) {
  window.moment = moment;
}

// @todo: point this at S3 or the SSR host, or whatever
const LOCALE_HOST = process.env.PUBLIC_URL;

export const languages = {
  en: 'English',
  de: 'Deutsche',
  es: 'Español',
  fr: 'Français',
  ru: 'русский',
  it: 'Italiano',
  pt: 'Português',
};

const appendScript = (path, id) =>
  new Promise((resolve, reject) => {
    if (!window.document) resolve();
    let script = document.querySelector(`script#${id}`);
    if (!script) {
      const script = document.createElement('script');
      script.setAttribute('id', id);
      script.onload = () => resolve(script);
      script.onerror = () => reject(script);
      script.src = path;
      document.body.appendChild(script);
    } else {
      resolve(script);
    }
  });

const getBrowserLanguage = () => get(window, 'navigator.language', '').slice(0, 2);
const version = process.env.REACT_APP_VERSION || '1.0.0-dev';

class Internationalization {
  constructor() {
    i18n.use(initReactI18next).use(Backend);
  }
  language = null;
  defaultLanguage = 'en';
  setLanguage = language => {
    this.language = language in languages ? language : getBrowserLanguage() || this.defaultLanguage;
  };
  getDateLocale = async language => {
    if (language === 'en') return;
    await appendScript(`${LOCALE_HOST}/date-locales/${language}.min.js`, language);
  };
  changeLanguage = async language => {
    if (!language || language === this.language) return;
    this.setLanguage(language);
    await this.getDateLocale(this.language);
    moment.locale(this.language);
    await i18n.changeLanguage(this.language);
  };
  init = async (initialStore, initialLanguage) => {
    this.setLanguage(initialLanguage);
    await i18n.init({
      load: 'languageOnly',
      backend: {
        loadPath: `${LOCALE_HOST}/locales/{{lng}}-${version}.json`,
        crossDomain: true,
        addPath: false,
      },
      saveMissing: false,
      debug: false,
      lng: this.language,
      fallbackLng: this.defaultLanguage,
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        format: (value, format, _lng) => {
          if (value instanceof Date) {
            return moment(value).format(format);
          }
          return value;
        },
      },
      react: {
        useSuspense: true,
      },
    });
    if (initialStore) {
      i18n.services.resourceStore.data = initialStore;
    }
    await this.getDateLocale(i18n.language || this.defaultLanguage);
  };
}

export default new Internationalization();
